import React from "react";
import ReactModal from "react-modal";
import Loader from "react-loader-spinner";

const ShowLoader = () => {
  return (
    <ReactModal
      isOpen={true}
      contentLabel="Loading"
      style={{
        overlay: {
          backgroundColor: "rgba(0,0,0,0.8)",
          zIndex: 100,
        },
        content: {
          position: "absolute",
          top: "0",
          left: "0",
          right: "0",
          margin: "auto",
          bottom: "0",
          width: "60px",
          height: "60px",
          border: "none",
          borderColor: "#63ceb0",
          borderRadius: "100vw",
          background: "rgba(0,0,0,0)",
          overflow: "hidden",
          WebkitOverflowScrolling: "touch",
          outline: "none",
        },
      }}
    >
      <Loader type="Grid" color="#039be6" height={"60px"} width={"60px"} />
    </ReactModal>
  );
};

ReactModal.setAppElement("#root");
export default ShowLoader;
